module.exports = __webpack_public_path__ + "img/icon-kjxy.b742a6dc.png";